import request from "@/services/request";
import store from "@/store";

async function getForm(nameForm = '') {
    try {
        let params = '';
        if (store.getters['auth/getFakeUser'])
            params = `?orgId=${store.getters['keycloak/getOrgId']}`
        const res = await request({
            endpoint: `/api/mag/${nameForm}${params? params: ''}`,
            method: 'get',
        });
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('error getFormOne');
        }
    } catch (e) {
        await store.dispatch('notifications/addNotification', {
            notificationStatus: 'error',
            notificationMessage: 'ошибка получения данных формы  ' + ' ' + e,
            timeout: 3000
        }, {root: true});
        console.error('error getFormOne' + e)
        throw new Error('error getFormOne' + e)
    }
}
async function getDbProfiles() {
    try {
        let params = '';
        if (store.getters['auth/getFakeUser'])
            params = `?orgId=${store.getters['keycloak/getOrgId']}`
        const res = await request({
            endpoint: `/api/mag/getDbProfiles${params? params: ''}`,
            method: 'get',
        });
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('error getDbProfiles');
        }
    } catch (e) {
        await store.dispatch('notifications/addNotification', {
            notificationStatus: 'error',
            notificationMessage: 'ошибка получения данных формы  ' + ' ' + e,
            timeout: 3000
        }, {root: true});
        console.error('error getDbProfiles' + e)
        throw new Error('error getDbProfiles' + e)
    }
}
async function deleteForm(nameForm = '', id) {
    try {
        const res = await request({
            endpoint: `/api/mag/${nameForm}/${id}`,
            method: 'delete',
        });
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('error getFormOne');
        }
    } catch (e) {
        await store.dispatch('notifications/addNotification', {
            notificationStatus: 'error',
            notificationMessage: 'ошибка удаления ' + ' ' + e,
            timeout: 3000
        }, {root: true});
        console.error('error getFormOne' + e)
        throw new Error('error getFormOne' + e)
    }
}
async function setForm(nameForm = '', payload) {
    try {
        const res = await request({
            endpoint: `/api/mag/${nameForm}`,
            method: 'post',
            body: payload
        });
        if (res.status === 200) {
            return res.data;
        } else {
            throw new Error('error setFormOne');
        }
    } catch (e) {
        await store.dispatch('notifications/addNotification', {
            notificationStatus: 'error',
            notificationMessage: 'ошибка получения данных формы  ' + ' ' + e,
            timeout: 3000
        }, {root: true});
        console.error('error setFormOne' + e)
        throw new Error('error setFormOne' + e)
    }
}
export {getForm, setForm, deleteForm, getDbProfiles}
